<template>
  <div class="card shadow-sm border-0 rounded-4 h-100">
    <div class="card-body p-3">
      <div class="d-flex flex-column  justify-content-between align-items-start gap-2 mb-2">
        <h6 class="text-uppercase text-muted m-0">Comportamiento</h6>
        <span class="badge rounded-pill px-3 py-1" :class="badgeClass">{{ label }}</span>
      </div>
      <h5 class="fw-semibold mb-1">{{ label }}</h5>
      <small class="text-muted d-block">
        Valor: <strong>{{ displayValue }}</strong> / {{ valueScale }}
      </small>
      <small class="text-muted">
        Puntos: <strong>{{ computedPoints.toFixed(1) }}</strong> (0–10)
      </small>

      <div
        class="progress mt-2"
        style="height:6px"
        role="progressbar"
        aria-label="Puntos por comportamiento"
        :aria-valuenow="Math.min(100, Math.max(0, (computedPoints/10)*100))"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        <div class="progress-bar" :style="{ width: (computedPoints/10)*100 + '%' }"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BehaviorCard",
  props: {
    /* Valor observado del comportamiento.
       - Si valueScale=5, se espera 0..5 (ej: tu input original) y se mapea a 0..10.
       - Si valueScale=10, se asume que ya viene 0..10. */
    value: { type: [Number, String], default: null },
    valueScale: { type: Number, default: 5 }, // 5 o 10
    // v-model:points => aporte al score total (0..10)
    points: { type: Number, default: 0 }
  },
  emits: ["update:points"],
  computed: {
    normalized() {
      if (this.value === "" || this.value === null || this.value === undefined) return null;
      const n = Number(this.value);
      if (!Number.isFinite(n)) return null;
      // clamp al rango declarado por valueScale
      const clamped = Math.min(Math.max(n, 0), this.valueScale);
      // convertir a 0..10
      return (clamped / this.valueScale) * 10;
    },
    computedPoints() {
      return this.normalized == null ? 0 : this.normalized;
    },
    label() {
      const p = this.computedPoints;
      if (p >= 8) return "Excelente conducta";
      if (p >= 4) return "Aceptable";
      return "Riesgoso";
    },
    badgeClass() {
      const p = this.computedPoints;
      if (p >= 8) return "bg-success-subtle text-success-emphasis";
      if (p >= 4) return "bg-warning-subtle text-warning-emphasis";
      return "bg-danger-subtle text-danger-emphasis";
    },
    displayValue() {
      // muestra el valor en su escala original para claridad (0..5 o 0..10)
      if (this.value === "" || this.value === null || this.value === undefined) return "—";
      const n = Number(this.value);
      if (!Number.isFinite(n)) return String(this.value);
      return Number.isInteger(n) ? String(n) : n.toFixed(1);
    }
  },
  watch: {
    computedPoints: {
      immediate: true,
      handler(val) {
        this.$emit("update:points", Number(val.toFixed(1)));
      }
    }
  }
};
</script>

<style scoped>
.bg-success-subtle { background-color: rgba(25,135,84,.12) !important; }
.text-success-emphasis { color: #146c43 !important; }
.bg-warning-subtle { background-color: rgba(255,193,7,.15) !important; }
.text-warning-emphasis { color: #997404 !important; }
.bg-danger-subtle { background-color: rgba(220,53,69,.12) !important; }
.text-danger-emphasis { color: #842029 !important; }
</style>
